import { render, staticRenderFns } from "./editButtonTemplate3.vue?vue&type=template&id=64dbe8dc"
import script from "./editButtonTemplate3.vue?vue&type=script&lang=js"
export * from "./editButtonTemplate3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports